"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactComponents = require("@canonical/react-components");
require("./TopicCard.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function TopicCard(_ref) {
  let {
    data,
    truncateTitle,
    truncateContent,
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactComponents.Card, {
    style: {
      borderTop: "3px solid #f2a031",
      minHeight: "182px"
    },
    onClick: () => {
      window.location.href = `/topics/${data.slug}`;
    },
    className: className
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: `p-muted-heading ${truncateTitle ? "u-truncate" : ""}`
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "p-link--soft",
    href: `/topics/${data.slug}`
  }, data.name)), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("p", {
    className: truncateContent ? "u-line-clamp--4" : ""
  }, data.description));
}
TopicCard.propTypes = {
  data: _propTypes.default.shape({
    slug: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired,
    description: _propTypes.default.string.isRequired
  }).isRequired,
  truncateTitle: _propTypes.default.bool,
  truncateContent: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = exports.default = TopicCard;